__turbopack_context__.v({
  "suggestionChip": "_4XSB4W_suggestionChip",
  "suggestionChipContent": "_4XSB4W_suggestionChipContent",
  "suggestionsContainer": "_4XSB4W_suggestionsContainer",
  "suggestionsList": "_4XSB4W_suggestionsList",
  "suggestionsTitle": "_4XSB4W_suggestionsTitle",
});
